import React from "react";
import "./NotFound.css";

const NotFound = () => {
  return <div>404 Not Found</div>;
};

export default NotFound;
